module.exports = __webpack_public_path__ + "img/012.a04e761f.jpeg";